import React, { Component } from 'react';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { find } from 'lodash';
import sanitizeHtml from 'sanitize-html';

import ToolTip from '../ToolTip/ToolTip';
import NumberInput from '../NumberInput/NumberInput';

import descrParams from '../../services/descrParams.js';

import './CalcSlide.scss';

class CalcSlide extends Component {
  get modificators() {
    const modificators = this.props.modificators;

    return modificators.map((modificator) => {
      return `calc-slide_${modificator}`;
    }).join(' ');
  }

  get symbol() {
    const symbol = this.props.symbol;
    const classes = classNames({
      'calc-slide__main-symbol': true,
      [`calc-slide__main-symbol_${symbol}`]: true
    });

    return (
      <div className={classes}></div>
    )
  }

  handleMovingSlider = (event) => {
    event.preventDefault();
    const $input = event.target;
    this.props.movingAfterFocus($input);
  }

  showTooltipByTab = (event) => {
    const code = event.keyCode ? event.keyCode : event.whitch;

    if (code === 9) {
      event.target.click();
    }
  }

  get fields() {
    const { currentLang } = this.props;
    return (
      this.props.fields.map((field, index) => {
        const descrOfParam = find(descrParams, { name: field.name });
        const tooltipText = sanitizeHtml(descrOfParam.html[currentLang], {allowedTags: false, allowedAttributes: false});

        return (
          <React.Fragment key={`calc-slide-${index}`}>
            {
              field.startSymbol &&
              <span className="calc-slide__math-symbol">{field.startSymbol}</span>
            }
            <label className="calc-slide__field">
              <span className="calc-slide__field-name">
                { field.name }
                <br/>
                { field.fullName }
              </span>
              <div className="calc-slide__field-input-wrap">
                <ToolTip
                  offset="10"
                  distance="75"
                  sticky={true}
                  stickyDuration={0}
                  html={
                    descrOfParam.html.ru && descrOfParam.html.ru.length > 0 ?
                    <div className="tooltip__inner" dangerouslySetInnerHTML={{ __html: tooltipText }}></div>
                    : <div />
                  }
                >
                  <Field
                    name={field.name}
                    className="calc-slide__field-input"
                    component={ NumberInput }
                    type="text"
                    placeholder={`0${field.suffix}`}
                    suffix={field.suffix}
                    onFocus={this.handleMovingSlider}
                    onKeyUp={this.showTooltipByTab}
                  />
                  <span className="calc-slide__field-border"></span>
                </ToolTip>
              </div>
            </label>
            {
              field.endSymbol &&
              <span className="calc-slide__math-symbol">{field.endSymbol}</span>
            }
            <span className="calc-slide__math-symbol">{field.operation}</span>
          </React.Fragment>
        )
      })
    )
  }

  render() {
    const { symbol, title } = this.props;

    return (
      <div className={`calc-slide ${this.modificators}`}>
        {
          symbol && 
          this.symbol
        }
        <div className="calc-slide__inner">
          <div className="calc-slide__title">
            { title }
          </div>
          <div className="calc-slide__fields">
            { this.fields }
          </div>
        </div>
      </div>
    )
  }
}

export default CalcSlide;


// WEBPACK FOOTER //
// ./src/components/CalcSlide/CalcSlide.js